import { Hero as RivalsHero } from '@sorare/core/src/components/landing/RivalsHeroBlock';

export const Hero = () => {
  return <RivalsHero scrollDownText={undefined} />;
};
